import {FiFigma} from 'react-icons/fi'
import {RiReactjsLine} from 'react-icons/ri'
import {FaServer} from 'react-icons/fa'
import {AiFillAppstore} from 'react-icons/ai'

const data = [
    {
        id: 1,
        icon: <FiFigma/>,
        title: 'UI/UX Design',
        desc: "Meus designs são modernos e intuitivos. Eu uso as regras padrão do setor para garantir que os usuários se divirtam usando seu produto."
    },
    {
        id: 2,
        icon: <RiReactjsLine/>,
        title: 'Frontend Development',
        desc: "Seu produto terá uma boa aparência e estará acessível em todos os dispositivos, incluindo celulares, tablets e computadores."
    },
    {
        id: 3,
        icon: <FaServer/>,
        title: 'Backend Development',
        desc: "A segurança do seu negócio/produto é levada a sério desde o início do projeto. Garantirei que seu site/aplicativo esteja protegido contra ataques."
    },
    {
        id: 4,
        icon: <AiFillAppstore/>,
        title: 'App Development',
        desc:"Ao contrário de outros desenvolvedores no mercado, vou construir um aplicativo que roda em dispositivos IOS e Android sem nenhum custo extra para você."
    }
]

export default data